module.exports = __webpack_public_path__ + "static/infuraShirt4-1ef4aa741190a9506467aefd3a1d4831.jpg";